module.exports = {

	custom(settings) {

		swal.fire(settings);

	},

	success(title, text) {

		swal.fire({
		    title: title || "Success!",
		    text: text || '',
		    icon: "success",
			timer: 3000,
			showConfirmButton: false,
			position: 'top-end',
			toast: true,
		});

	},

	error(title, text) {

		swal.fire({
		    title: title || "Error!",
		    text: text || '',
		    icon: "error",
		});

	},

	overlay(title, text, icon, confText) {

		swal.fire({
		    title: title,
		    text: text,
		    icon: icon,
		    confirmButtonText: confText,
		    confirmButtonColor: "rgba(16, 144, 45, 0.5)"
		});

	}

}
